import { Navigate, Route } from "react-router";
import { useSelector } from "react-redux";
import { selectUser } from "../store/features/userSlice";
import { hasPermission } from "../lib/utils";
import UnAuthorized from "../pages/auth/UnAuthorized";

const ProtectedRoute = ({ permission, children }) => {
  const user = useSelector(selectUser);

  if (!hasPermission(user.role, permission)) {
    return <UnAuthorized />;
    // return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute; 